import VanillaScrollspy from 'vanillajs-scrollspy'

const menuScroll = document.querySelector('.menu-scroll')

if (menuScroll) {
  const scrollSpy = new VanillaScrollspy(menuScroll)
  scrollSpy.init()
}



// WEBPACK FOOTER //
// ./scripts/scrollspy.js